import BoardFilterButton from './BoardFilterButton'
import localize from '../../higherOrderComponents/localize'
import {
  unassignedFilterAdd,
  unassignedFilterRemove,
  assignedFilterAdd,
  assignedFilterRemove,
  userFilterSet,
  userFilterRemove,
  filterToggleOn,
  filterToggleOff,
  ASSIGNED_FILTER_KEY,
  UNASSIGNED_FILTER_KEY,
  filterClear
 } from '../../store/taskFilter'
import { connect } from 'react-redux'

const mapStateToProps = (state, ownProps) => {
  const taskFilter = state.taskFilter[state.project.id]
  return {
    project: state.project,
    isFilteringEnabled: taskFilter.isOn,
    isAssignedFilterOn: !!taskFilter.filters.some(key => key === ASSIGNED_FILTER_KEY),
    isUnassignedFilterOn: !!taskFilter.filters.some(key => key === UNASSIGNED_FILTER_KEY),
    filteredUsers: taskFilter.filteredUsers,
    projectMembers: state.projectMembers,
    userInfo: state.userInfo
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => {
  const projectId = stateProps.project ? stateProps.project.id : undefined
  return {
    ...stateProps,
    ...ownProps,
    unassignedFilterChange: (isOn) => dispatch(isOn ? unassignedFilterAdd(projectId) : unassignedFilterRemove(projectId)),
    assignedFilterChange: (isOn) => dispatch(isOn ? assignedFilterAdd(projectId) : assignedFilterRemove(projectId)),
    userFilterChange: (users) => dispatch(users.length > 0 ? userFilterSet(projectId, users) : userFilterRemove(projectId)),
    filterToggleChange: (isOn) => dispatch(isOn ? filterToggleOn(projectId) : filterToggleOff(projectId)),
    clearFilter: () => dispatch(filterClear(projectId))
  }
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(localize(BoardFilterButton))



// WEBPACK FOOTER //
// ./src/components/BoardFilterButton/index.js